"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["colspan"];
const tagStore_1 = require("../../../stores/tag/tagStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'NameHeaderRow',
    props: {
        tableName: null
    },
    setup(__props) {
        const tagStore = (0, tagStore_1.useTagStore)();
        return (_ctx, _cache) => {
            return (__props.tableName)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", _hoisted_1, [
                    (0, vue_2.createElementVNode)("td", {
                        colspan: (0, vue_2.unref)(tagStore).activeColumnCount,
                        class: "bg-gray-darker text-white border-b-1 border-gray font-bold text-center px-4 py-2"
                    }, (0, vue_2.toDisplayString)(__props.tableName), 9, _hoisted_2)
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
